export const settings = {
  word: "Einstellungen",
  hello: "Hallo",
  save_changes: "Änderungen speichern",
  change: "Ändern",
  abort: "Abbrechen",
  email: {
    change_email: "E-mail-Adresse ändern",
    current_email: "Deine derzeitige E-Mail-Adresse lautet:",
  },
  username: {
    change_username: "Benutzername ändern",
    current_username: "Du verwendest derzeit den Benutzernamen:",
  },
  profile: {
    title: "Profil",
  },
  profileImage: {
    change_profile_image_in_settings:
      "Ändere dein Profilbild / deinen Nutzernamen in den Profileinstellungen.",
  },
  account: {
    delete_account: "Konto löschen",
    email_changed: "Deine E-Mail Adresse wurde geändert.",
  },
  password: {
    reset_password: "Password zurücksetzen",
    labels: {
      password: "Passwort",
    },
  },
};
